module.exports = __webpack_public_path__ + "img/spider-black-widow.373fc50c.svg";